module.exports = __webpack_public_path__ + "static/media/swipe_to_like.395d9fb9.gif";